import * as React from "react"
import {isEmpty as _isEmpty} from "lodash"
import {ILabtestPrescription, IDiagnosticLabTestItem} from "@curefit/care-common"
import TemplatedList from "../../TemplatedList"
import ModelFactory from "../../../models/ModelFactory"
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader"
import {AppConstants} from "../../../utils/AppConstants";
import CTA, {CTATheme} from "../../common/CallToAction";

/**
 * Created by aditya on 28/01/18.
 */

let LabTestEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "name", display: "DIAGNOSTIC TEST", mandatory: true},
    {label: "condition", display: "RECORDED VALUE", mandatory: true},
    {label: "unit", display: "UNIT"},
    {label: "when", display: "RECORDED DATE", mandatory: true}
];

let LabTestEditorHeaderInfosForKMH: ICustomHeaderInfo[] = [
    {label: "name", display: "TEST", mandatory: true},
    {label: "condition", display: "INSTRUCTIONS"},
    {label: "when", display: "WHEN"},
    {label: "instructions", display: "COMMENTS"},
    {label: "weekdays", display: ""},
    {label: "reminder", display: "REMIND"}
];


export interface LabTestEditorProps {
    patientId: number,
    curefitUserId: number;
    consultationType?: string,
    fetchStaticLabTestsData?: (input: string) => Promise<any>,
    fetchStaticDiagnosticLabTests: (input: string) => Promise<any>
    updatedLabTest: {item: IDiagnosticLabTestItem}[],
    updateLabTest: (updatedLabTests: {item: ILabtestPrescription}[]) => void,
    labTest: any,
    savePatientDiagnosticLabTests: () => void,
    isSaving: boolean,
    hideLabTestForm: () => void
}

class PatientDiagnosticLabTestsEditor extends React.Component<LabTestEditorProps> {

    constructor(props: LabTestEditorProps) {
        super(props);
    }

    onLabTestRemove = (index: number) => {
        let currUpdatedLabTests = Object.assign([], this.props.updatedLabTest);
        currUpdatedLabTests.splice(index, 1);
        this.props.updateLabTest(currUpdatedLabTests);
    }

    onLabTestChange = (updatedLifeStyle: {item: IDiagnosticLabTestItem}, index: number) => {
        let currUpdatedLabTest = Object.assign([], this.props.updatedLabTest);
        currUpdatedLabTest[index] = updatedLifeStyle;
        this.props.updateLabTest(currUpdatedLabTest);
    }

    render() {
        let saveButtonValue = this.props.isSaving ? "Saving..." : "Save";
        let consultationType = this.props.consultationType;
        let consultationHeader = !_isEmpty(consultationType) && consultationType === AppConstants.ConsultationTypes.KMH ? LabTestEditorHeaderInfosForKMH : LabTestEditorHeaderInfos;
        return (
            <div className="patient-labTests-editor">
                <CustomHeader headerInfos={consultationHeader} rootCls={"patient-labTest"}/>
                <TemplatedList templateName={"diagnosticlabTest"} commonProps={{labTests: this.props.labTest, fetchStaticDiagnosticLabTests: this.props.fetchStaticDiagnosticLabTests, consultationType, patientId: this.props.patientId, curefitUserId: this.props.curefitUserId}}
                defaultItem={{item: ModelFactory.createNewDiagnosticLabTest()}}
                listItems={this.props.updatedLabTest}
                onItemRemove={this.onLabTestRemove}
                onItemChange={this.onLabTestChange}/>
                <div className="save-button">
                    <CTA innerText={saveButtonValue} theme={CTATheme.PRIMARY} onClick={this.props.savePatientDiagnosticLabTests} customStyle={{display: "inline"}}/>
                    <span onClick={this.props.hideLabTestForm}>Cancel</span>
                </div>
            </div>
        );
    }
}

export default PatientDiagnosticLabTestsEditor